import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumericInput from 'react-numeric-input';
import cns from 'classnames';

class VerbNumericInput extends Component {
    static propTypes = {
        placeholder: PropTypes.string,
        input: PropTypes.object,
        disabled: PropTypes.bool,
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
        step: PropTypes.number,
        formatFunction: PropTypes.func,
        parseFunction: PropTypes.func,
        className: PropTypes.string,
        precision: PropTypes.number
    };

    /**
     * Handles NumericInput's onChange event.  The value is passed in as a number and a string.
     * @param {number} valueAsNumber
     * @private
     */
    _onChange = (valueAsNumber) => {
        if (this.props.input && this.props.input.onChange) {
            let formattedValue = valueAsNumber;
            if (!formattedValue && this.props.minValue) {
                formattedValue = this.props.minValue;
            }
            if (formattedValue && this.props.maxValue && formattedValue > this.props.maxValue) {
                formattedValue = this.props.maxValue;
            }

            formattedValue = formattedValue || 0;
            this.props.input.onChange(formattedValue);
        }
    };

    render() {
        const {
            placeholder,
            input = {},
            disabled,
            minValue,
            maxValue,
            step = 1,
            precision,
            formatFunction = null,
            parseFunction = null,
            className = ''
        } = this.props;
        const { value = '' } = input;

        return (
            <div className={cns(className)}>
                <NumericInput
                    className={cns('form-control')}
                    value={value}
                    min={minValue}
                    max={maxValue}
                    step={step}
                    precision={precision}
                    format={formatFunction}
                    parse={parseFunction}
                    disabled={disabled}
                    onChange={this._onChange}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}

export default VerbNumericInput;
